import { Controller } from "@hotwired/stimulus";
import { enter, leave } from "el-transition";

// Connects to data-controller="dropdown"
export default class extends Controller {
  static targets = ["button", "list"];
  static values = { expanded: Boolean };

  connect() {
    if (this.hasListTarget && !this.listTarget.classList.contains("hidden")) {
      this.listTarget.classList.add("hidden");
    }
    this.expandedValue = false;
    this.buttonTarget.ariaExpanded = this.expandedValue;
  }

  toggleVisibility() {
    if (this.expandedValue) {
      Promise.all([leave(this.listTarget)]).then(() => {
        this.listTarget.classList.add("hidden");
        this.expandedValue = !this.expandedValue;
        this.buttonTarget.ariaExpanded = this.expandedValue;
      });
    } else {
      this.listTarget.classList.remove("hidden");
      enter(this.listTarget);
      this.expandedValue = !this.expandedValue;
      this.buttonTarget.ariaExpanded = this.expandedValue;
    }
  }

  hideMenu(event) {
    if (this.expandedValue && !this.element.contains(event.target)) {
      Promise.all([leave(this.listTarget)]).then(() => {
        this.listTarget.classList.add("hidden");
        this.expandedValue = false;
      });
    }
  }
}
